/**
 * Thin wrapper that mounts ProsConsWorkspace inside the evaluation
 * shell. All pros/cons UI — ProsConsSiteColumn, ProConItem,
 * ProConFormModal — lives in `components/proscons/` (H1).
 *
 * The legacy single-site-selector layout is gone. The legacy
 * `ProConForm.tsx` remains on disk as an orphan (replaced by
 * `proscons/ProConFormModal.tsx`); cleanup deferred to the
 * closing-sweep pass.
 */

import { useOutletContext } from 'react-router-dom'
import type { EvaluationOutletContext } from '../Evaluations_ShowCN'
import ProsConsWorkspace from './proscons/ProsConsWorkspace'

const EvaluationProsCons = () => {
	const { evalId } = useOutletContext<EvaluationOutletContext>()
	return <ProsConsWorkspace evalId={evalId} />
}

export default EvaluationProsCons
